import * as React from 'react';
import { WebDate } from '../../../../WebDate';
import * as main from '../../main.module.scss';
import * as tt from './style.module.scss';
export const Timetable = ({ id, widgetFree }) => {
  return (
    <section className={tt.tt} id={'tt'}>
      <div className="container">
        <div className={tt.container}>
          <h2 className={main.title}>Расписание обучения</h2>
          <div className={tt.info}>
            <div className={tt.infoLeft}>
              <div className={tt.btnWrap}>
                <button className={tt.btnEmpty} aria-label={'btn-empty'}></button>
                <button className={tt.btnEmpty} aria-label={'btn-empty'}></button>
                <button className={tt.btnDay}>
                  <span className={tt.day}>день</span>
                  <span className={tt.num}>1</span>
                </button>
                <button className={tt.btnDay}>
                  <span className={tt.day}>день</span>
                  <span className={tt.num}>2</span>
                </button>
                <button className={tt.btnDay}>
                  <span className={tt.day}>день</span>
                  <span className={tt.num}>3</span>
                </button>
                <button className={tt.btnDay}>
                  <span className={tt.day}>день</span>
                  <span className={tt.num}>4</span>
                </button>
                <button className={tt.btnDay}>
                  <span className={tt.day}>день</span>
                  <span className={tt.num}>5</span>
                </button>

                <button className={tt.btnEmpty} aria-label={'btn-empty'}></button>
                <button className={tt.btnEmpty} aria-label={'btn-empty'}></button>
                <button className={tt.btnEmpty} aria-label={'btn-empty'}></button>
                <button className={tt.btnEmpty} aria-label={'btn-empty'}></button>
                <button className={tt.btnEmpty} aria-label={'btn-empty'}></button>
                <button className={tt.btnEmpty} aria-label={'btn-empty'}></button>
                <button className={tt.btnEmpty} aria-label={'btn-empty'}></button>

                <button className={tt.btnEmpty} aria-label={'btn-empty'}></button>
                <button className={tt.btnEmpty} aria-label={'btn-empty'}></button>
                <button className={tt.btnEmpty} aria-label={'btn-empty'}></button>
                <button className={tt.btnEmpty} aria-label={'btn-empty'}></button>
                <button className={tt.btnEmpty} aria-label={'btn-empty'}></button>
                <button className={tt.btnEmpty} aria-label={'btn-empty'}></button>
                <button className={tt.btnEmpty} aria-label={'btn-empty'}></button>

                <button className={tt.btnEmpty} aria-label={'btn-empty'}></button>
                <button className={tt.btnEmpty} aria-label={'btn-empty'}></button>
                <button className={tt.btnEmpty} aria-label={'btn-empty'}></button>
                <button className={tt.btnEmpty} aria-label={'btn-empty'}></button>
                <button className={tt.btnEmpty} aria-label={'btn-empty'}></button>
                <button className={tt.btnEmpty} aria-label={'btn-empty'}></button>
                <button className={tt.btnEmpty} aria-label={'btn-empty'}></button>
              </div>
              <ul className={tt.orgList}>
                <li>
                  Длительность урока: <strong>1 час 25 минут — 1 час 55 минут</strong>
                </li>
                <li>
                  Уроки начинаются <strong>в 20:00 (Мск)</strong>
                </li>
              </ul>
            </div>
            <div className={tt.infoRight}>
              <h3>
                Начало марафона{' '}
                <span>
                  <WebDate id={id} />
                </span>
              </h3>
              <ul className={tt.daysList}>
                <li>
                  <span>1 день:</span>
                  <p>
                    Что такое развитие мозга.
                    <br /> Что и как в нем можно развивать, а что нет?
                  </p>
                </li>
                <li>
                  <span>2 день:</span>
                  <p>Методики понимания или можно ли развить свой интеллект?</p>
                </li>
                <li>
                  <span>3 день:</span>
                  <p>Скорочтение, скорослушание и эффективное чтение</p>
                </li>
                <li>
                  <span>4 день:</span>
                  <p>
                    Новый язык или новая профессия, есть ли разница?
                    <br />
                    Знания и навыки и особенности в их получении
                  </p>
                </li>
                <li>
                  <span>5 день:</span>
                  <p>Управление изменениями в жизни через тренировку мозга</p>
                </li>
              </ul>
            </div>
          </div>
          <div className={tt.reg}>
            <div className={tt.form}>
              <h3>Заполните поля и мы отправим доступ на&nbsp;почту</h3>
              {widgetFree}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
